<template>
  <div id="app">
    <router-view/>
    <!-- <index_home /> -->
  </div>
</template>

<script>
// import index_home from './components/qhdIndex.vue'

export default {
  name: 'App',
  // components: {
  //   index_home,
  // },
}
</script>

<style>
html,
body {
  width: 100%;
  height: 100%;
}
div {
  height: 100%;
  width: 100%;
}
* {
  margin: 0;
  padding: 0;
}
</style>
